import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=37b8233b&scoped=true"
import script from "./LandingHeader.vue?vue&type=script&lang=js"
export * from "./LandingHeader.vue?vue&type=script&lang=js"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=37b8233b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8233b",
  null
  
)

export default component.exports